import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import creditSoldProductListAction from './creditSoldProductList.action.json' with { type: 'json' }
import { creditSoldProductObject } from '../creditSoldProductObject'

export const creditSoldProductExpression = expression(creditSoldProductObject.shape)

const creditSoldProductListDefinition = defineAction({
  ...creditSoldProductListAction,

  input: z.object({
    filter: creditSoldProductExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      description: 'Descrição',
      quantity: 'Quantidade',
      totalValue: 'Valor total',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(creditSoldProductObject),
    count: z.number(),
  }),
})

export default creditSoldProductListDefinition

